import { Button, Tabs } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { StickyContainer, Sticky } from 'react-sticky';
import useQuery from '../../../../util/useQuery';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import Tab7 from './Tab7';
import ModalFail from '../../../../components/Shared/modal/fail';
import IconEnoughData from '../../../../assets/Images/icons/icon-enough-data';
import { useTranslation } from 'react-i18next';
import { ROUTER } from '../../../../constants/router';
import UserService from '../../../../services/UserService';
import Tab6 from '../DataflowDetailView/Tab6';
import Tab8 from './Tab8';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;
const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{
                    ...style,
                }}
            />
        )}
    </Sticky>
);
export default function TabsDetail({
    loading,
    detail,
    getDataFlowDetail,
    databaseDetail,
    getDataBaseDetail,
    editMode,
    setEditMode,
    dataFlowInfo
}) {
    const navigate = useNavigate();
    const { businessProcessId } = useParams();
    const { t } = useTranslation();
    const params = useQuery();
    const [openTabDB, setOpenTabDB] = useState(false);
    const [isOpenFail, setIsOpenFail] = useState(false);
    const [msgError, setMsgError] = useState({
        msg1: '',
        msg2: '',
    });
    const mode = params.get('mode');
    const viewMode = mode === 'view';

    useEffect(() => {
        if (detail?.collectDataDestruction?.storageLocation) {
            const storageLocation =
                detail?.collectDataDestruction?.storageLocation.find(
                    (m) => m === '42776e1af77c11ec8bf4fa163e89ed46'
                );
            if (storageLocation) {
                setOpenTabDB(true);
            }
        }
    }, [detail]);

    const checkTab = async (key) => {
        if (detail?.collectData) {
            if (detail?.categoryPersonalData) {
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=${key}`
                );
            } else {
                setMsgError({
                    msg1: t('dataFlow.errMsgTab2'),
                    msg2: t('dataFlow.errMsg2Tab2'),
                });
                setIsOpenFail(true);
            }
        } else {
            setMsgError({
                msg1: t('dataFlow.errMsgTab1'),
                msg2: t('dataFlow.errMsg2Tab1'),
            });
            setIsOpenFail(true);
        }
    };

    const currentPackage = UserService.currentPackage();

    const checkPackage4 = useMemo(() => {
        return openTabDB && currentPackage === 4;
    }, [currentPackage, openTabDB]);

    const changePage = useCallback(
        (key) => {
            const tabNumber = Number(params.get('tab'));
            if (key === 'right' && tabNumber < 8) {
                if (tabNumber === 4) {
                    if (!checkPackage4) {
                        navigate(
                            `${
                                ROUTER.DS_INVENTORY.DATAFLOW
                            }/${businessProcessId}?tab=${tabNumber + 2}`
                        );
                        return;
                    } else {
                        checkTab(5);
                        return;
                    }
                }
                if (viewMode) {
                    navigate(
                        `${
                            ROUTER.DS_INVENTORY.DATAFLOW
                        }/${businessProcessId}/view?tab=${
                            tabNumber + 1
                        }&mode=view`
                    );
                } else {
                    navigate(
                        `${
                            ROUTER.DS_INVENTORY.DATAFLOW
                        }/${businessProcessId}?tab=${tabNumber + 1}`
                    );
                }
            }
            if (key === 'left' && tabNumber > 1) {
                if (tabNumber === 6) {
                    if (!checkPackage4) {
                        navigate(
                            `${
                                ROUTER.DS_INVENTORY.DATAFLOW
                            }/${businessProcessId}?tab=${tabNumber - 2}`
                        );
                        return;
                    } else {
                        checkTab(5);
                        return;
                    }
                }
                if (viewMode) {
                    navigate(
                        `${
                            ROUTER.DS_INVENTORY.DATAFLOW
                        }/${businessProcessId}/view?tab=${
                            tabNumber - 1
                        }&mode=view`
                    );
                } else {
                    navigate(
                        `${
                            ROUTER.DS_INVENTORY.DATAFLOW
                        }/${businessProcessId}?tab=${tabNumber - 1}`
                    );
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [businessProcessId, params.get('tab')]
    );

    const operationsSlot = {
        left: (
            <Button
                disabled={params.get('tab') === '1'}
                onClick={() => changePage('left')}
                className="mr-4"
            >
                <LeftOutlined />
            </Button>
        ),
        right: (
            <Button
                disabled={params.get('tab') === '8'}
                onClick={() => changePage('right')}
            >
                <RightOutlined />
            </Button>
        ),
    };

    const bubble = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="text-error"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z"
                strokeWidth={0}
                fill="currentColor"
            />
        </svg>
    );

    return (
        <div className="bg-white rounded-xl p-4 py-6 my-4 col-span-2">
            <StickyContainer>
                <Tabs
                    tabBarExtraContent={operationsSlot}
                    className="tabs"
                    onChange={(key) => {
                        if (key === '5') {
                            checkTab(key);
                        } else {
                            if (viewMode) {
                                navigate(
                                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=${key}&mode=view`
                                );
                            } else {
                                navigate(
                                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=${key}`
                                );
                            }
                        }
                    }}
                    activeKey={params.get('tab') || '1'}
                    renderTabBar={renderTabBar}
                >
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('RoPA.DataCollection')}{' '}
                                {!detail?.collectData && bubble}
                            </span>
                        }
                        key={1}
                    >
                        <Tab1
                            setEditMode={setEditMode}
                            collectData={detail?.collectData}
                            getDataFlowDetail={getDataFlowDetail}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('RoPA.TypeOfPersonalData')}{' '}
                                {!detail?.categoryPersonalData && bubble}
                            </span>
                        }
                        key={2}
                    >
                        <Tab2
                            setEditMode={setEditMode}
                            categoryPersonalData={detail?.categoryPersonalData}
                            getDataFlowDetail={getDataFlowDetail}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('dataFlow.Reference')}{' '}
                                {detail?.referenceDocuments?.length === 0 &&
                                    bubble}
                            </span>
                        }
                        key={3}
                    >
                        <Tab3
                            setEditMode={setEditMode}
                            referenceDocuments={detail?.referenceDocuments}
                            getDataFlowDetail={getDataFlowDetail}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('RoPA.StorageAndDestruction')}{' '}
                                {!detail?.collectDataDestruction && bubble}
                            </span>
                        }
                        key={4}
                    >
                        <Tab4
                            dataFlowInfo={dataFlowInfo}
                            collectDataDestruction={
                                detail?.collectDataDestruction
                            }
                            getDataFlowDetail={getDataFlowDetail}
                        />
                    </TabPane>
                    {checkPackage4 && (
                        <TabPane tab={t('RoPA.Database')} key={5}>
                            <Tab7
                                loading={loading}
                                detail={detail}
                                databaseInfo={databaseDetail}
                                getDataBaseDetail={getDataBaseDetail}
                                getDataFlowDetail={getDataFlowDetail}
                                editMode={editMode}
                            />
                        </TabPane>
                    )}
                    <TabPane tab={t('dataFlow.Remarks')} key={6}>
                        <Tab5
                            remarks={detail?.remarks}
                            getDataFlowDetail={getDataFlowDetail}
                        />
                    </TabPane>
                    <TabPane tab={t('dcdpo.DataControllerTab')} key={7}>
                        <Tab8
                            editMode={editMode}
                            dcDpo={detail?.dcDpo}
                            getDataFlowDetail={getDataFlowDetail}
                        />
                    </TabPane>
                    <TabPane tab={t('dataFlow.DataDiagram')} key={8}>
                        <Tab6
                            dataFlowInfo={dataFlowInfo}
                            isView={false}
                            editMode={editMode}
                            getDataFlowDetail={getDataFlowDetail}
                            detail={detail}
                        />
                    </TabPane>
                </Tabs>
            </StickyContainer>
            <ModalFail
                icon={<IconEnoughData />}
                open={isOpenFail}
                title={t('dataFlow.notEnoughInformation')}
                text={
                    <>
                        {msgError?.msg1} <br />
                        {msgError?.msg2}
                    </>
                }
                handelClose={() => {
                    setIsOpenFail(false);
                    navigate(
                        `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=1`
                    );
                }}
            />
        </div>
    );
}
